import styled from "styled-components";
import {BaseButton, buttonStyles} from "./index";

export const TertiaryButton = styled(BaseButton)`
	${({theme}) => buttonStyles(theme.button.tertiary)}
`;
